<eda-dialog2 [header]="title" width="40vw" height="50vh" [overflow]="'auto'" (apply)="saveGradientConfig()" (close)="closeDialog()" (notstyles)="saveGradientConfig(true)" [showNotStyles]=true>
  <div content class="flex flex-col flex-1 overflow-hidden h-full">

    <p-tabView [(activeIndex)]="activeTabIndex">

      <!-- Tab 1: Gradiente de color -->
      <p-tabPanel header="Gradiente de color" i18n-header="@@gradientTab">
        <div class="space-y-3 mt-4">
          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
            <span class="font-medium" i18n="@@gradientMin">Min</span>
            <div class="flex items-center gap-2">
              <input class="text-base text-right text-slate-500 font-mono" [(ngModel)]="min">
              <p-colorPicker [(ngModel)]="min" [disabled]="noStyle" format="hex" appendTo="body" />
            </div>
          </div>
          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
            <span class="font-medium" i18n="@@gradientMax">Max</span>
            <div class="flex items-center gap-2">
              <input class="text-base text-right text-slate-500 font-mono" [(ngModel)]="max">
              <p-colorPicker [(ngModel)]="max" [disabled]="noStyle" format="hex" appendTo="body" />
            </div>
          </div>
        </div>
      </p-tabPanel>

      <!-- Tab 2: Codigo semaforico -->
      <p-tabPanel header="Código semafórico" i18n-header="@@semaphoreTab">
        <div class="space-y-3 mt-4">
          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
            <div>
              <span class="font-medium mr-4">{{controller.params.col.header}} <span i18n="@@aboveThreshold">es mayor que:</span></span>
              <p-inputNumber [(ngModel)]="value1" [disabled]="noStyle" mode="decimal"
              [minFractionDigits]="0" [maxFractionDigits]="4" />
            </div>
            <div class="flex items-center gap-2">
              <input class="text-base text-right text-slate-500 font-mono" [(ngModel)]="color1">
              <p-colorPicker [(ngModel)]="color1" [disabled]="noStyle" format="hex" appendTo="body" />
            </div>
          </div>

          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
            <span class="font-medium">{{controller.params.col.header}} <span i18n="@@betweenThresholds">mayor que</span> {{value2}} <span i18n="@@betweenThresholds2">y menor que</span> {{value1}}</span>
            <div class="flex items-center gap-2">
              <input class="text-base text-right text-slate-500 font-mono" [(ngModel)]="color2">
              <p-colorPicker [(ngModel)]="color2" [disabled]="noStyle" format="hex" appendTo="body" />
            </div>
          </div>

          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
            <div>
              <span class="font-medium mr-4">{{controller.params.col.header}} <span i18n="@@belowThreshold">es menor que:</span></span>
              <p-inputNumber [(ngModel)]="value2" [disabled]="noStyle" mode="decimal"
              [minFractionDigits]="0" [maxFractionDigits]="4" />
            </div>
            <div class="flex items-center gap-2">
              <input class="text-base text-right text-slate-500 font-mono" [(ngModel)]="color3">
              <p-colorPicker [(ngModel)]="color3" [disabled]="noStyle" format="hex" appendTo="body" />
            </div>
          </div>
        </div>
      </p-tabPanel>

    </p-tabView>

  </div>

</eda-dialog2>
